import { observer } from 'mobx-react-lite'
import { ReactElement, useState } from 'react'
import { useSpecificConditionStore } from '../../../store/specificConditions/SpecificConditionsStore'
import { StoreInstances } from '../../../store/StoreInstancesContainer'
import { useLaborLookup } from '../../../store/labor/LaborStore'
import { PartsCatalogType } from '../../../store/partsCatalog/PartsCatalog'
import { defaultTheme } from '../../../theme/index'
import { Button } from '../../../ui-components/forms/Button'
import styled from 'styled-components'
import { NiceModalHandler, show } from '@ebay/nice-modal-react'
import { SpecificConditionsModal } from 'src/features/specificConditions/components/SpecificConditionsModal'

interface DrawerFooterProps {
  setLaborResult: (laborResult: boolean) => void
  modal: NiceModalHandler<Record<string, unknown>>
}

const DrawerFooter = observer(
  ({ setLaborResult, modal }: DrawerFooterProps): ReactElement => {
    const [loading, setLoading] = useState(false)
    const { lookup: laborStore } = useLaborLookup()
    const {
      fetchSpecificConditionQuestions,
      areAllQuestionsAnswered,
      processQuestions,
    } = useSpecificConditionStore()

    const fetchAndShowResults = (): void => {
      modal.remove()
      setLaborResult(true)
    }

    const goToSearchResults = (): void => {
      fetchAndShowResults()
    }

    const handleShowFitmentConditions = async (): Promise<void> => {
      setLoading(true)
      try {
        const formattedVehicle = {
          ...StoreInstances.searchStore.currentVehicle,
          initialized: undefined,
        }

        const specificConditionQuestions =
          await fetchSpecificConditionQuestions(
            formattedVehicle,
            laborStore.terminologies,
            PartsCatalogType.LABOR_SEARCH
          )
        if (
          specificConditionQuestions.length > 0 &&
          !areAllQuestionsAnswered()
        ) {
          show(SpecificConditionsModal, {
            proceed: goToSearchResults,
          })
        } else {
          processQuestions()
          fetchAndShowResults()
        }
      } catch (_e) {
        // eslint-disable-next-line no-console
        console.error('Error fetching labor specific conditions')
      } finally {
        setLoading(false)
      }
    }

    return (
      <Footer>
        <DecorativeBox />
        <GeLaborDataWrapper>
          <Button
            onClick={handleShowFitmentConditions}
            text="getLaborData"
            style={{ margin: 0 }}
            size="small"
            disabled={laborStore.disabledButton}
            loading={loading}
          />
        </GeLaborDataWrapper>
      </Footer>
    )
  }
)
export default DrawerFooter

const Footer = styled.div`
  display: flex;
`

const DecorativeBox = styled.div`
  flex-grow: 1;
  background: ${defaultTheme.colors.disabledBackground};
`

const GeLaborDataWrapper = styled.div`
  margin-left: 1rem;
`
